// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"css_wrapper__2e5Xb","wrapper__text-block":"css_wrapper__text-block__3a8aF","wrapper__text-block__text":"css_wrapper__text-block__text__1NPfc"};